import http from '@/libs/axios'

export function getContactsList(query) {
  return http({
    url: '/contact/contact/',
    method: 'GET',
    params: query,
  })
}

export function getContactsListCard(query) {
  return http({
    url: '/contact/contact/',
    method: 'GET',
    params: query,
  })
}

export function getContactId(id) {
  return http({
    url: `/contact/contact/${id}/`,
    method: 'GET',
  })
}

export function getContactContractsById(id) {
  return http({
    url: `/contract/contract/${id}/contracts_of_contact/`,
    method: 'GET',
  })
}

export function createContact(data) {
  return http({
    method: 'POST',
    url: '/contact/contact/',
    data,
  })
}

export function createContactAgent(data) {
  return http({
    method: 'POST',
    url: '/contact/agent/',
    data,
  })
}

export function getAgent(query) {
  return http({
    url: '/contact/agent/',
    method: 'GET',
    params: query,
  })
}

export function deleteContact(id) {
  return http({
    method: 'DELETE',
    url: `/contact/contact/${id}/`,
  })
}

export function updateContactAgent(data) {
  return http({
    method: 'PATCH',
    url: `/contact/agent/${data.id}/`,
    data,
  })
}

export function updateContact(data) {
  return http({
    method: 'PATCH',
    url: `/contact/contact/${data.id}/`,
    data,
  })
}

export function getReportList(params) {

  return http({
    url: `/contract/report/`,
    method: "GET",
    params
  })
}

export function getReportOne(id) {

  return http({
    url: `/contract/report/${id}`,
    method: "GET"
  })
}

export function createReport(data) {

  return http({
    url: `/contract/report/${data.id}/add_pto/`,
    method: "POST",
    data: data.data
  })
}

export function createReport2(data) {

  return http({
    url: `/contract/report/`,
    method: "POST",
    data
  })
}

export function deleteReportPto(data) {

  return http({
    url: `/contract/report/${data.id}/remove_pto/`,
    method: "DELETE",
    data: data.data
  })
}
